import Loadable from 'react-loadable';

export const SaveListingModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SaveListingModalContainer" */
      './SaveListingModalContainer.dynamic'
    ),
  loading: () => <div />,
});
